/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */

import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import './LoanDataDisplay.scss';
import fmt from 'indian-number-format';

// Define TypeScript interfaces
interface ExpenseReportItem {
  date: string;
  branch: string;
  type: string;
  amount: number;
  description: string;
}

interface ExpenseReportProps {
  data: ExpenseReportItem[];
}

const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const columns: ColumnsType<ExpenseReportItem> = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    render: (date: string) => formatDate(date),
  },
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
  },
  {
    title: 'Expenses Head',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    render: (amount: number) => fmt.format(amount),
  },
  {
    title: 'Remarks',
    dataIndex: 'description',
    key: 'description',
  },
];

const ExpenseReportDisplay: React.FC<ExpenseReportProps> = ({ data }) => {
  return (
    <div className="loan-data-container">
      <h2>Expense Report</h2>
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(_, idx) => (idx !== undefined ? idx.toString() : '')}
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};

export default ExpenseReportDisplay;
